// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD2X0deq5lDA5b2WpMpKsbok1H67cXqCis",
    authDomain: "overview-38b1c.firebaseapp.com",
    databaseURL: "https://overview-38b1c.firebaseio.com",
    projectId: "overview-38b1c",
    storageBucket: "overview-38b1c.appspot.com",
    messagingSenderId: "402793874563"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
